define.alias("shared/components/shared/plan-recommendation/index", "media/components/shared/plan-recommendation/index");